module.exports = __webpack_public_path__ + "img/ArmadilloChecklist.6f52b0a6.svg";